<div [class]="getContainerClasses()">
  <i [class]="getIconClasses()"></i>
  <h3 class="text-lg font-semibold mb-2">{{ title | translate }}</h3>
  <p class="text-sm text-center px-4">{{ description | translate }}</p>
</div>
